import { defineStore } from "pinia";

// NOTE: components/SideNav.vue と components/SideNavLink.vue の Tailwind クラス(w-12 / w-sidenav)と対応する
export const SIDE_NAV_WIDTH = {
  expanded: "208px",
  collapsed: "48px",
} as const;

const STORAGE_KEY = "sideNavCollapsed";
// tailwind.config.js の screens.tab (max: 768px) と対応する
const TAB_MAX_WIDTH = 768;

interface State {
  isCollapsed: boolean;
}

// NOTE: プライベートブラウジングなど localStorage が使えない環境でも動くようにする
const readStorage = (): boolean | null => {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return saved === null ? null : saved === "true";
  } catch {
    return null;
  }
};

const writeStorage = (isCollapsed: boolean): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(isCollapsed));
  } catch {
    // 保存できなくても表示自体は切り替わるため握りつぶす
  }
};

/**
 * 折りたたみ状態の初期値を決める。
 * 保存値があればそれを優先し、無ければ画面幅から決める。
 *
 * NOTE: SPA(nuxt.config.ts の ssr: false)なのでストアの生成時点で window を参照できる。
 * 初回描画より前に確定させることで、展開状態が一瞬見えてから縮むちらつきを防いでいる。
 */
const resolveInitialCollapsed = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  const saved = readStorage();
  return saved === null ? window.innerWidth <= TAB_MAX_WIDTH : saved;
};

export const useSideNavStore = defineStore("sideNav", () => {
  const state: State = reactive({
    isCollapsed: resolveInitialCollapsed(),
  });

  const actions = {
    toggle() {
      state.isCollapsed = !state.isCollapsed;
      writeStorage(state.isCollapsed);
    },
  };

  return {
    ...toRefs(readonly(state)),
    ...actions,
  };
});
